module.exports = __webpack_public_path__ + "img/join_us.99d44ac3.png";